export default {
  tags: 'Étiquettes',
};
